<template>
  <div class="bread-wrap">
    <span :class="['iconfont', icon, 'bread-crumb-icon', breadListState.length == 1? 'top-level' : '']"></span>
    <el-breadcrumb separator="/">
      <template v-for="(item, index) in breadListState">
        <el-breadcrumb-item v-if="item.title" :key="item.path"
          :class="{ 'last-bread-item': index === breadListState.length - 1 }">
          <span v-if="item.redirect === 'noredirect' || index === breadListState.length - 1"
            :class="{ 'no-redirect': true, 'last-bread-txt': index === breadListState.length - 1 }">{{ item.title
            }}</span>
          <router-link v-else :to="item.redirect || item.path">{{ item.title }}</router-link>
        </el-breadcrumb-item>
      </template>
    </el-breadcrumb>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import routes from '@/router/routes.js'
export default {
  name: 'Breadcrumb',
  data() {
    return {
      levelList: null,
      showFirstBreadParent: true
    }
  },
  computed: {
    ...mapState({
      breadListState: index => index.app.breadListState
    }),
    icon: function () {
      let icon = '';
      if (this.breadListState.length > 0) {
        icon = this.breadListState[0].icon;
      }
      return icon;
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb(true)
  },
  methods: {
    ...mapActions(['breadListAdd', 'breadListRemove', 'breadListSet']),
    getBreadcrumb(isReload) {
      const { $utils, $route } = this
      let breadLevel = $utils.isEmpty($route.meta.breadLevel) ? 0 : $route.meta.breadLevel
      // 如果是动态的 可指定具体面包屑名称
      const title = $route.query.breadName
        ? $route.query.breadName
        : $route.meta.title
          ? $route.meta.title
          : ''
      const breadLength = this.breadListState.length
      const curName = $route.name
      const curPath = $route.fullPath
      const icon = $route.meta?.icon
      const newBread = { name: curName, path: curPath, title, icon: icon }
      const breadListStorage = sessionStorage.getItem('breadListStorage')

      // query 中存在 breadLevel 字段优先使用
      breadLevel = $route.query.breadLevel ? $route.query.breadLevel : breadLevel
      if (breadLevel === 0) {
        this.breadListRemove(0)
        if (breadLevel === 0) {
          this.breadListAdd(newBread)
        }
      } else {
        if (!isReload) {
          if (breadLength <= breadLevel) {
            this.breadListAdd(newBread)
          } else {
            this.breadListRemove(parseInt(breadLevel) + 1)
          }
        } else {
          if (!$utils.isEmpty(breadListStorage)) {
            this.breadListSet(JSON.parse(breadListStorage))
          }
        }
      }
      this.breadlist = this.breadListState
      sessionStorage.setItem('breadListStorage', JSON.stringify(this.breadlist))
    },
    getParentBreadName() {
      const { breadListState, $utils } = this
      const firstBread = $utils.isEmpty(breadListState) ? null : breadListState[0]
      if ($utils.isEmpty(firstBread)) {
        return null
      }
      const firstBreadParent = this.recursionByRouteName(
        {
          children: routes
        },
        firstBread.name
      )
      const showFirstBreadParent = !(
        $utils.isEmpty(firstBreadParent) ||
        $utils.isEmpty(firstBreadParent.meta) ||
        $utils.isEmpty(firstBreadParent.meta.title)
      )
      this.showFirstBreadParent = showFirstBreadParent
      return !showFirstBreadParent ? '' : firstBreadParent.meta.title
    },
    recursionByRouteName(data, routeName) {
      const { $utils } = this
      let result = null
      if ($utils.isEmpty(data.children)) {
        return
      }
      data.children.every((child, index) => {
        if (child.name === routeName) {
          result = data
          return false
        } else if (!$utils.isEmpty(child.children)) {
          result = this.recursionByRouteName(child, routeName)
          return !$utils.isEmpty(result)
        } else {
          return true
        }
      })
      return result
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.bread-wrap {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: var(--navbar-bread-crumb-height);

  .bread-crumb-icon {
    margin-right: var(--navbar-bread-crumb-icon-margin-right);
    color: var(--navbar-bread-crumb-color);
    font-size: var(--navbar-bread-crumb-icon-size);
  }

  .bread-crumb-icon.top-level {
    color: var(--navbar-bread-crumb-last-bread-color);
  }

  .el-breadcrumb {
    .el-breadcrumb__item {
      a {
        color: var(--navbar-bread-crumb-color);
        font-size: var(--navbar-bread-crumb-fontsize);
        font-style: normal;
        font-weight: 350;
        line-height: normal;
      }
    }

    .el-breadcrumb__item.last-bread-item {
      .last-bread-txt {
        font-size: var(--navbar-bread-crumb-fontsize);
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        color: var(--navbar-bread-crumb-last-bread-color);
      }
    }

    /deep/ .el-breadcrumb__separator {
      font-size: var(--navbar-bread-crumb-seperator-fontsize);
      color: var(--navbar-bread-crumb-seperator-color);
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin: var(--navbar-bread-crumb-seperator-margin);
    }
  }
}
</style>
